export default "__VITE_ASSET__7cc95bee__"